import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getParamConfigDropdownData = createApi(`ParamConfigDropdownDataSlice`,"GET");

const ParamConfigDropdownDataSlice = createSlice({
  name: 'ParamConfigDropdownDataSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getParamConfigDropdownData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getParamConfigDropdownData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getParamConfigDropdownData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ParamConfigDropdownDataSlice.reducer;